<template>
  <div class='customer-cases-page customer-image-header-container'>
    <t-header :class='{fixed: fixedHeader}'/>
    <div class='top-container'>
      <p>马兰头为客户提供丰富、稳定、可靠的场景化云服务，<br/>越来越多的用户正在使用基于马兰头所开发的产品服务</p>
    </div>
    <section class='case-section' v-for='(key, index) in Object.keys(listMap)' :key='index'>
      <a :id='`section${index}`'><h2>{{key}}</h2></a>
      <ul>
        <li v-for='(data, idx) in listMap[key]' :key='idx' @click='redirect(data.url)'>
          <img :src='data.image'/>
          <div class='name'>{{data.name}}</div>
          <p class='intro'>{{data.intro}}</p>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import customerCases from '../../utils/customerCases';
import THeader from '../../components/header';
import imageHeaderMixin from '../../mixins/imageHeader';

export default {
  name: 'Case',
  components: {
    THeader,
  },
  mixins: [imageHeaderMixin],
  data() {
    const listMap = {};
    customerCases.sort((a, b) => {
      a.sort = a.sort || 99999;
      b.sort = b.sort || 99999;
      return a.sort - b.sort;
    });
    customerCases.forEach(item => {
      if (listMap[item.type]) {
        listMap[item.type].push(item);
      } else {
        listMap[item.type] = [item];
      }
    })
    return {
      listMap,
      scrollTopMax: 140,
    }
  },
}
</script>

<style lang="less">
.customer-cases-page {
  padding-bottom: 20px;
  .top-container {
    >p {
      font-size: 21px;
      line-height: 35px;
      font-weight: 400;
      color: #fff;
      text-align: center;
      padding-top: 130px;
    }
  }
  .case-section {
    width: 1060px;
    margin: 0 auto;
    text-align: center;
    h2 {
      font-size: 32px;
      font-weight: 600;
      color: #333333;
      line-height: 45px;
      margin: 30px 20px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 250px;
        height: 250px;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 2px 11px 0px rgba(210,219,255,0.50);
        padding: 25px 15px;
        margin-bottom: 20px;
        border: 2px solid transparent;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        &:hover {
          border: 2px solid #b1c4ff;
          box-shadow: 0px 0px 12px 0px rgba(210,221,231,0.50);
        }
        &:not(:nth-of-type(4n)) {
          margin-right: 20px;
        }
        img {
          height: 104px;
          // width: 200px;
        }
        .name {
          margin-top: 10px;
          font-size: 18px;
          font-weight: 400;
          color: #333;
        }
        .intro {
          margin-top: 10px;
          font-size: 16px;
          font-weight: 400;
          color: #666;
          line-height: 22px;
          overflow: hidden;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          box-orient: vertical;
          display: -webkit-box;
        }
      }
    }
  }
}
</style>